export enum Pet {
  Dog = 'dog',
  Cat = 'cat',
  PocketPet = 'pocketPet',
  Exotic = 'exotic',
  Equine = 'equine',
}
